var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_11_1",
    "data-name": "Composant 11 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.852,
    height: 92.171,
    viewBox: "0 0 98.852 92.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2140",
    "data-name": "Trac\\xE9 2140",
    d: "M17.49,0A17.49,17.49,0,1,1,0,17.49,17.49,17.49,0,0,1,17.49,0Z",
    transform: "translate(63.872)",
    fill: "#f5c66e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2077",
    "data-name": "Trac\\xE9 2077",
    d: "M772.191,604.284l5.033,4.314,8.268-8.268",
    transform: "translate(-696.993 -586.803)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2155",
    "data-name": "Trac\\xE9 2155",
    d: "M629.016,299.943H618.363V292a19.585,19.585,0,0,0-19.532-19.5h-.026A19.564,19.564,0,0,0,579.3,292v7.939H568.655l-8.342,60.934h77.04Zm-30.181-24.938a17.085,17.085,0,0,1,17,17v7.945h-34V292A17.083,17.083,0,0,1,598.835,275.005Zm-28.743,27h9.21v11.782l-.837.467a4.3,4.3,0,1,0,4.2,0l-.836-.467V302h34v11.782l-.836.467a4.305,4.305,0,1,0,4.2,0l-.837-.466V302h9.216l7.764,56.815H562.322Z",
    transform: "translate(-560.313 -268.706)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartOk);
export default __webpack_public_path__ + "static/media/cart_ok.a522b3d34c6519798293efd99326517d.svg";
export { ForwardRef as ReactComponent };